import { InformationForBilling } from "../../../pages/InformationForBilling/InformationForBilling";
import { ModalComponent } from "../../Modal/ModalComponent/ModalComponent";

const ModalAddInn = ({
    setIsModal
}) => {

    return (
        <ModalComponent
            title='Заполните данные'
            onClose={(e) => setIsModal(false)}
            style={{height: 'auto'}}
            child={
                <div className="modal-add-inn">
                    <InformationForBilling
                        modal
                        isEdit
                    />
                </div>}
        />
    );
};

export { ModalAddInn };
